export default "__VITE_ASSET__LQAeRRZw__"